import { useState } from "react";
import { Alert, Button, Icon } from "@app/ui";
import { useAuth } from "../auth/AuthContext.js";
import { useT } from "../i18n.js";
import { EmailVerifyModal } from "./EmailVerifyModal.js";

/**
 * A slim reminder shown in the app shell while the signed-in user's email is
 * unverified. Its single action opens the in-app code-entry modal (which also
 * hosts "resend"). Renders nothing once verified.
 */
export function EmailVerifyBanner() {
  const t = useT();
  const { user } = useAuth();
  const [open, setOpen] = useState(false);

  if (!user || user.emailVerified) return null;

  return (
    /* icon={false}: the strip runs edge to edge, so the icon rides inside the
       centred row with the message instead of hugging the window edge. */
    <Alert type="warning" className="app-banner" icon={false}>
      <div className="app-banner-row">
        <span className="app-banner-msg">
          <Icon name="warning" size={14} className="text-[var(--az-warning-accent)]" />
          {t("verify.bannerText")}
        </span>
        <Button size="sm" variant="primary" onClick={() => setOpen(true)}>
          {t("verify.enterCode")}
        </Button>
      </div>
      <EmailVerifyModal open={open} onClose={() => setOpen(false)} />
    </Alert>
  );
}
